import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { useConfig } from '../../config';
import { LoadingProgress } from '../../layout';
import { fromAuth, useAppDispatch } from '../../store';
import { useQuery, login } from '../../routes';

const LoginComponent = () => {
  const { config } = useConfig();
  const { get, queryString } = useQuery();
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(fromAuth.selectIsAuthenticated);
  const redirectRef = useRef(get('redirect') ?? '/');
  const view = get('view');
  const [newLogin] = useState(Boolean(get('new_login')));

  useEffect(() => {
    analytics.page();
  }, []);

  useEffect(() => {
    if (!config) {
      return;
    }
    if (!isAuthenticated) {
      const authConfig = {
        redirectUrl: `${window.location.origin}${process.env.PUBLIC_URL}${login.path}?${queryString()}`,
      };

      dispatch(fromAuth.doLogin({ authConfig, rememberMe: true }));
    }
  }, [config]);

  if (!config) return <></>;

  if (isAuthenticated) {
    // do logout if user access forgot password page and user is logged-in
    if (view === 'forgot_password') {
      const uri = new URL(`${config?.keyCloakUrl}/realms/${config?.keyCloakRealmId}/login-actions/reset-credentials?client_id=${config?.keyCloakClientId}`);
      window.location.replace(uri.toString());
    }
    if (newLogin) {
      return <></>;
    }
    return <Navigate to={redirectRef.current} replace />;
    // if we have a queryParam called orgId and user is authenticated,
    // direct to Detail page of that org.
  }

  return (
    <LoadingProgress fullscreen />
  );
};

export default LoginComponent;
